const {
  GET_ALL_BONCOMMANDE_REQUEST,
  GET_ALL_BONCOMMANDE_SUCCESS,
  GET_ALL_BONCOMMANDE_FAIL,
  ADD_BONCOMMANDE_REQUEST,
  ADD_BONCOMMANDE_SUCCESS,
  ADD_BONCOMMANDE_FAIL,
  GET_BONCOMMANDE_REQUEST,
  GET_BONCOMMANDE_SUCCESS,
  GET_BONCOMMANDE_FAIL,
  UPDATE_BONCOMMANDE_REQUEST,
  UPDATE_BONCOMMANDE_SUCCESS,
  UPDATE_BONCOMMANDE_FAIL,
  DELETE_BONCOMMANDE_REQUEST,
  DELETE_BONCOMMANDE_SUCCESS,
  DELETE_BONCOMMANDE_FAIL,
  ADD_BCARTICLE_REQUEST,
  ADD_BCARTICLE_SUCCESS,
  ADD_BCARTICLE_FAIL,
  GET_BCARTICLE_REQUEST,
  GET_BCARTICLE_SUCCESS,
  GET_BCARTICLE_FAIL,
  UPDATE_BCARTICLE_REQUEST,
  UPDATE_BCARTICLE_SUCCESS,
  UPDATE_BCARTICLE_FAIL,
  DELETE_BCARTICLE_REQUEST,
  DELETE_BCARTICLE_SUCCESS,
  DELETE_BCARTICLE_FAIL
} = require("../../actionTypes/Achat/BonCommande");

function getAllBonCommandes(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_BONCOMMANDE_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_BONCOMMANDE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_BONCOMMANDE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getBonCommande(state = { data: {} }, action) {
  switch (action.type) {
    case GET_BONCOMMANDE_REQUEST:
      return { loading: true, data: {} };
    case GET_BONCOMMANDE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_BONCOMMANDE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addBonCommande(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_BONCOMMANDE_REQUEST:
      return { loading: true, data: {} };
    case ADD_BONCOMMANDE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_BONCOMMANDE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateBonCommande(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_BONCOMMANDE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_BONCOMMANDE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_BONCOMMANDE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteBonCommande(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_BONCOMMANDE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_BONCOMMANDE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_BONCOMMANDE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addBCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_BCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_BCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_BCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getBCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case GET_BCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case GET_BCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_BCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateBCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_BCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_BCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_BCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteBCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_BCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_BCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_BCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addBonCommande,
  getBonCommande,
  updateBonCommande,
  deleteBonCommande,
  getAllBonCommandes,
  addBCArticle,
  getBCArticle,
  updateBCArticle,
  deleteBCArticle
};
